import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {map} from 'rxjs/operators';

import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MembershipsService {

  private url = environment.urlApiRest;

  constructor( private http: HttpClient) { }

  get(){
    return this.http.get(`${this.url}memberships?testing=1`).pipe(
    map( resp => { return resp['response']['data'][0];}));
  }

  getByCountry(country = "Mexico"){
    return this.http.get(`${this.url}memberships/country/${country}`).pipe(
    map( resp => { return resp['response']['data'];}));
  }


  getById(id : number){
    return this.http.get(`${this.url}memberships/${id}?testing=1`).pipe(
    map( resp => { return resp['response']['data'];}));
  } 

}
